import { render, staticRenderFns } from "./AsociarMensajesFormEdit2.vue?vue&type=template&id=38434e6f&scoped=true&"
import script from "./AsociarMensajesFormEdit2.vue?vue&type=script&lang=ts&"
export * from "./AsociarMensajesFormEdit2.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarMensajesFormEdit2.vue?vue&type=style&index=0&id=38434e6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38434e6f",
  null
  
)

export default component.exports